export default {"src":"/_next/static/media/living-room.768ca1cf.svg","height":46,"width":46,"blurWidth":0,"blurHeight":0};